<template>
  <div class="articlelist-container">
    <div>
      <a-row>
        <a-col :span="2">
          <bread-crumb />
        </a-col>
        <a-col :span="22">
          <table-search
            @onSearch="onSearch"
            @onChangeStatus="onChangeStatus"
            @onChangeType="onChangeType"
            @onChangeCompany="onChangeCompany"
            @onStartTime="onStartTime"
            @onEndTime="onEndTime"
            @editAndAdd="editAndAdd"
            @onExport="onExport"
            @onExportTask="onExportTask"
            @onExportRepresent="onExportRepresent"
          />
        </a-col>
      </a-row>
    </div>
    <div class="global-table-container">
      <div class="recommend-btn-container">
        <a-button
          type="danger"
          class="recommend-btn"
          :loading="delLoading"
          @click="handleDelete"
        >
          删除
        </a-button>
        <span
          v-show="isShowError"
          class="errorMsg"
        >请至少选择一项</span>
      </div>

      <a-table
        :columns="columns"
        :data-source="data"
        :loading="loading"
        :row-key="record => record.id"
        :pagination="{
          pageSize,
          total,
          current,
          showTotal: total => `共${total}条`,
        }"
        :row-selection="{
          selectedRowKeys,
          onChange:onchangeCheck,
        }"
        @change="changePage"
      >
        <template
          slot="feedback_count"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => onFeed(record)"
          >{{ record.feedback_count }}</a>
        </template>
        <template
          slot="promoter"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => checkPromoter(record)"
          >点击查看</a>
        </template>
        <template
          slot="task"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => checkResource(record)"
          >点击查看</a>
        </template>
        <template
          slot="operation"
          slot-scope="text, record"
        >
          <a
            href="javascript:;"
            @click="() => handleReview(record)"
          >详情</a>
          <a-divider type="vertical" />
          <a
            href="javascript:;"
            @click="() => editAndAdd(record)"
          >编辑</a>
          <a-divider type="vertical" />
          <popconfirm-button
            text="删除"
            alert-title="确定删除？"
            @onDelete="() => onDelete(record)"
          />
        </template>
      </a-table>
    </div>
    <promoter-modal
      :data="promoterData"
      :visible="promoterVisible"
      @onCancel="cancelPromoter"
    />
    <resource-modal
      :data="resourceData"
      :visible="resourceVisible"
      @onCancel="cancelResource"
    />
  </div>
</template>
<script>
import {columns} from './data/index';
import TableSearch from './components/search';
import promoterModal from './modal/promoterModal';
import resourceModal from './modal/resourceModal';
export default {
  components: {TableSearch, promoterModal, resourceModal},
  data() {
    return {
      columns,
      data: [],
      pageSize: 10,
      current: 1,
      total: 0,
      loading: false,
      btnIsLoading: false,
      title: '',
      visible: false,
      id: '',
      isShowError: false,
      selectedRowKeys: [],
      delLoading: false,
      keyword: undefined,
      company_id: 0,
      task_type: 0,
      task_status: 0,
      polymorphic_type: '1',
      start_time: undefined,
      end_time: undefined,
      companyData: [],
      promoterData: [],
      promoterVisible: false,
      resourceData: [],
      resourceVisible: false,
      token: '',

    };
  },
  async mounted() {
    this.token=localStorage.getItem('token');
    await this.getCompanyData();
    // 获取表格数据
    await this.getTableData(
      {
        page: 1,
        pageSize: this.pageSize,
        keyword: this.keyword,
        polymorphic_type: this.polymorphic_type,
        company_id: this.company_id,
        task_status: this.task_status,
        task_type: this.task_type,
        start_time: this.start_time?this.$Date(this.start_time):undefined,
        end_time: this.end_time?this.$Date(this.end_time):undefined,
      });
  },
  methods: {
    // 获取药企
    async getCompanyData() {
      let result = await this.$http.post('/company/getCompanyList');
      if (result.data.status === 1) {
        let data = result.data.data.data_list.map((item)=>{return {name: item.team_name?item.team_name:item.companyInfo.qichacha_name, ...item};});
        this.companyData=data;
      }
    },
    // 获取表格数据
    async getTableData(params) {
      this.loading=true;
      let result = await this.$http.post('/task/getList', params);
      if (result.data.status===1) {
        this.loading = false;
        this.total = result.data.data.count;
        let data = result.data.data.data_list;
        let temp = [];
        data.forEach((item) => {
          let obj = {
            id: item.id,
            company_id: this.companyData.find((item1)=>item1.id===item.company_id).name,
            admin_name: item.admin_name,
            admin_area: item.admin_area,
            task_name: item.task_name,
            task_type_name: item.task_type_name,
            time: `${this.$Format(item.start_time)}~${this.$Format(item.end_time)}`,
            create_time: item.create_time,
            score: item.score,
            feedback_count: item.feedback_count,
            data: item,
          };
          temp.push(obj);
        });
        this.data = temp;

      }
    },
    // 查看推广员
    async checkPromoter(record){
      console.log('checkPromoter -> record', record);
      this.promoterVisible=true;
      let result = await this.$http.post('/task/getTaskPromoters', {task_id: record.id});
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.promoterData = data;
      }
    },
    // 取消查看推广员
    cancelPromoter(){
      this.promoterVisible=false;
    },
    // 查看资料
    async checkResource(record){
      this.resourceVisible=true;
      let result = await this.$http.post('/task/getTaskDatas', {task_id: record.id});
      if (result.data.status === 1) {
        let data = result.data.data.data_list;
        this.resourceData = data;
      }
    },
    // 取消查看资料
    cancelResource(){
      this.resourceVisible=false;
    },
    // 查看反馈数
    onFeed(record){
      this.$router.push({path: '/promotefeed', query: {id: record.id}});
    },
    // 审核
    handleReview(record){
      this.$router.push({path: '/task/check', query: {id: record.id}});
    },
    // 编辑或新增
    editAndAdd(record) {
      if(record){
        this.$router.push({path: '/task/edit', query: {id: record.id}});
      }else{
        this.$router.push({path: '/task/add'});
      }
    },
    // 取消编辑或新增
    onCancel() {
      this.visible = false;
    },
    // 搜索
    onSearch(value) {
      this.current=1;
      this.keyword=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择状态
    onChangeStatus(value){
      this.current=1;
      this.task_status=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择类型
    async onChangeType(value){
      this.current=1;
      this.task_type=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择公司
    onChangeCompany(value){
      this.current=1;
      this.company_id=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择开始时间
    onStartTime(value){
      this.current=1;
      this.start_time=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 选择结束时间
    onEndTime(value){
      this.current=1;
      this.end_time=value;
      this.getTableData(
        {
          page: 1,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
    // 导出任务详情
    async onExport(){
      if(!this.company_id){
        this.$message.warning('请选择企业！');
        return;
      }
      window.location.href=`${this.uploadUrl}/task/adminTaskExport?drug_id=${this.company_id}
       &start_time=${this.start_time?this.$Date(this.start_time):''}&end_time=${this.end_time?this.$Date(this.end_time):''}
       &task_type=${this.task_type?this.task_type:''}&task_status=${this.task_status?this.task_status:''}&keyword=${this.keyword?this.keyword:''}
       &token=${this.token}`;
    },
    // 导出任务统计
    onExportTask(){
      if(!this.company_id){
        this.$message.warning('请选择企业！');
        return;
      }
      window.location.href=`${this.uploadUrl}/task/exportTaskCount?drug_id=${this.company_id}
       &start_time=${this.start_time?this.$Date(this.start_time):''}&end_time=${this.end_time?this.$Date(this.end_time):''}
       &task_type=${this.task_type?this.task_type:''}&task_status=${this.task_status?this.task_status:''}&keyword=${this.keyword?this.keyword:''}
       &token=${this.token}`;
    },
    // 导出代表统计
    onExportRepresent(){
      if(!this.company_id){
        this.$message.warning('请选择企业！');
        return;
      }
      window.location.href=`${this.uploadUrl}/task/exportTaskDetail?drug_id=${this.company_id}
       &start_time=${this.start_time?this.$Date(this.start_time):''}&end_time=${this.end_time?this.$Date(this.end_time):''}
       &task_type=${this.task_type?this.task_type:''}&task_status=${this.task_status?this.task_status:''}&keyword=${this.keyword?this.keyword:''}
       &token=${this.token}`;
    },
    // 删除单个
    async onDelete(record) {
      let result=await this.$http.post('/task/del', {id: record.id});
      if(result.data.status===1){
        this.$message.success('操作成功！');
        this.getTableData(
          {
            page: 1,
            pageSize: this.pageSize,
            keyword: this.keyword,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            task_status: this.task_status,
            task_type: this.task_type,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // check表格
    onchangeCheck(selectedRowKeys, selectedRows){
      this.selectedRowKeys = selectedRowKeys;
      this.isShowError=false;
    },
    // 批量删除
    async handleDelete() {
      if(this.selectedRowKeys.length===0){
        this.isShowError=true;
        return ;
      }
      this.delLoading=true;
      let result = await this.$http.post('/task/moreDel', {
        ids: this.selectedRowKeys,
      });
      this.delLoading=false;
      if (result.data.status === 1) {
        this.$message.success('操作成功！');
        this.selectedRowKeys=[];
        this.getTableData(
          {
            page: 1,
            pageSize: this.pageSize,
            keyword: this.keyword,
            polymorphic_type: this.polymorphic_type,
            company_id: this.company_id,
            task_status: this.task_status,
            task_type: this.task_type,
            start_time: this.start_time?this.$Date(this.start_time):undefined,
            end_time: this.end_time?this.$Date(this.end_time):undefined,
          });
      }
    },
    // 分页
    changePage(pagination) {
      this.current=pagination.current;
      this.getTableData(
        {
          page: this.current,
          pageSize: this.pageSize,
          keyword: this.keyword,
          polymorphic_type: this.polymorphic_type,
          company_id: this.company_id,
          task_status: this.task_status,
          task_type: this.task_type,
          start_time: this.start_time?this.$Date(this.start_time):undefined,
          end_time: this.end_time?this.$Date(this.end_time):undefined,
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.articlelist-container {
  .recommend-btn-container {
    margin-bottom: 10px;
    .recommend-btn {
      margin-right: 10px;
    }
    .errorMsg{
      color: red;
      font-size: 16px;
      margin-left: 10px;
    }
  }
}
</style>
